import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask1900To1999Service {

  constructor() { }
}
